import { render } from "./ForgottenPasswordPage.vue?vue&type=template&id=1bccb2ca"
import script from "./ForgottenPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgottenPasswordPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__